import axios from 'axios';
import url from '../../utils/url';

export default {
  namespaced: true,
  state: {
    alarms: [],
    device_id: null,
    events: [],
    alarmsCount: 0,
  },
  getters: {
    alarms: state => state.alarms,
    device_id: state => state.device_id,
    events: state => state.events,
  },
  actions: {
    async fetchNewAlarms({ commit }, payLoad) {
      const { data } = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device_id}/alarms?perPage=999999&sourceRoute=detailViewAlarm`);
      const alarmData = {
        device_id: payLoad.device_id,
        alarms: data,
      };
      // console.log(data);
      commit('setAlarms', alarmData);
    },
    async updateAlarms({ commit }, payLoad) {
      const { data } = await axios.get(url`/api/v1/accounts/${payLoad.account}/devices/${payLoad.device_id}/alarms?perPage=999999&sourceRoute=detailViewAlarm`);
      const alarmData = {
        device_id: payLoad.device_id,
        alarms: data,
      };
      commit('setAlarms', alarmData);
    },
  },
  mutations: {
    setAlarms(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.alarms = data.alarms;
      // eslint-disable-next-line no-param-reassign
      state.device_id = data.device_id;
    },
    setEvents(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.events = data;
    },
    clearAlarms(state) {
      // eslint-disable-next-line no-param-reassign
      state.alarms = [];
    },
  },
};
